import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  OnDestroy,
} from "@angular/core";
import { Router } from "@angular/router";
import swal from "sweetalert2";
import { LocalStorageService, SessionStorageService } from "ngx-webstorage";
import { HeaderService } from "./header.service";
import { LogoutService } from "./logout.service";
import { AfterContentInit, ElementRef } from "@angular/core";
import { CommonService } from "../../common/common.service";
import { Pipe, PipeTransform } from "@angular/core";
import { DatePipe } from "@angular/common";
import { AgentRequestsService } from "../agent-requests/agent-requests.service";
import { KycService } from "../kyc/kyc.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
  providers: [HeaderService, DatePipe],
})
export class HeaderComponent implements OnInit, OnDestroy {
  messages = [];
  // dummyData = [
  //   {
  //     failureCount:"0",
  //     message:"Upload Failed! Please check the data again.",
  //     status:0,
  //     successCount:"0",
  //     taskId:"847",
  //     timestamp: "1526476625912",
  //     topic:"Wallet Management",
  //     type:"Wallet to Wallet",
  //     url:null,
  //     userId:"241",
  //     userName:"241-inder"
  //   }
  // ]
  // connection;
  message;
  mess: any = [];
  notificationCount: Number;
  userId: String;
  userObj: any = this.common.getUserInfo();
  pendingAgentRequestsCount: number = 0;
  agentRequestsInterval: any;
  pendingKycRequestsCount: number = 0;
  kycRequestsInterval: any;
  loading: boolean = false;

  get shouldShowAgentRequestIcon(): boolean {
    if (!this.userObj) {
      return true;
    }
    const agentRequest =
      this.userObj["agentRequests"] ||
      this.userObj["agentRequest"] ||
      this.userObj["agentrequest"] ||
      (this.userObj.access &&
        (this.userObj.access["agentRequest"] ||
          this.userObj.access["agentrequest"] ||
          this.userObj.access["agentRequests"]));
    return agentRequest !== "H";
  }

  get shouldShowKycIcon(): boolean {
    if (!this.userObj) {
      return true;
    }
    const kyc =
      this.userObj["kyc"] ||
      (this.userObj.access && this.userObj.access["kyc"]);
    return kyc !== "H";
  }
  constructor(
    private datePipe: DatePipe,
    private common: CommonService,
    private router: Router,
    private ref: ChangeDetectorRef,
    private sessionStorageService: SessionStorageService,
    private logoutService: LogoutService,
    private localStorageService: LocalStorageService,
    private headerService: HeaderService,
    private elementRef: ElementRef,
    private agentRequestsService: AgentRequestsService,
    private kycService: KycService
  ) {
    this.userId = this.userObj.entityId;

    // for (var i=0; i < this.dummyData.length; i++){
    //   console.log(this.dummyData[i].timestamp);
    //     this.dummyData[i]['formattedTime'] = new Date(parseInt(this.dummyData[i].timestamp));
    //     console.log(this.dummyData[i]['formattedTime']);
    // }

    common.logOutCalled$.subscribe((data) => {
      this.logOut();
    });
  }

  headInterval;
  ngOnInit() {
    /*this.mess = [{
      "userId": 1,
      "userName": "1000000092",
      "message": "Upload Success, But there are some invalid entries found in upload.",
      "type": "path bca",
      "topic": "path bca",
      "url": "/mfs-common-utilities/commonutils/download/1000000092_1507706659487/invalid/entries",
      "taskId": "456",
      "successCount": "12",
      "failureCount": "10"
    }, {
      "userId": 1,
      "userName": "1000000092",
      "message": "Upload Success, But there are some invalid entries found in upload.",
      "type": "path bca",
      "topic": "path bca",
      "url": "/mfs-common-utilities/commonutils/download/1000000092_1507706659487/invalid/entries",
      "taskId": "456",
      "successCount": "12",
      "failureCount": "10"
    }]
    this.notificationCount = this.mess.length;*/
    this.headInterval = setInterval(() => {
      let loggedAt = this.common.getStorage("loggedAt");
      if (loggedAt) {
        let timeSpent: number = new Date().getTime() - loggedAt;
        if (timeSpent > 25 * 60 * 1000) {
          // ***DANGER*** login ByPass - AMMY-NEED-TO-REMOVE-IT
          // this.logoutService.refresh().subscribe((data) => {
          //   console.log(data);
          //   console.log(data['status']);
          //   if (data['status'] == "success") {
          //     this.common.token = "bearer " + data['object'];
          //     this.common.setStorage("loggedAt", new Date().getTime());
          //   }
          //   // else {
          //   //   this.logoutService.warnMessage("Unable to authorize user. Kindly login again!");
          //   //   this.logOut();
          //   // }
          // }, error => {
          //   this.logOut();
          //   this.logoutService.warnMessage("Unable to authorize user. Kindly login again!");
          // });
        }
      }
      ///for inacivity
      this.CheckIdleTime();
    }, 10000);

    if (this.shouldShowAgentRequestIcon) {
      // Fetch initial count on login (API call)
      this.fetchInitialCount();

      // Read count from localStorage immediately (fallback)
      this.updateCountFromStorage();

      // Listen to storage events for updates from other tabs/components
      window.addEventListener("storage", () => {
        this.updateCountFromStorage();
      });

      // Poll API every 30 seconds to get latest pending count
      this.agentRequestsInterval = setInterval(() => {
        this.fetchInitialCount();
      }, 30000);
    }

    if (this.shouldShowKycIcon) {
      // Fetch initial KYC count on login
      this.fetchKycCount();
      this.updateKycCountFromStorage();

      // Poll API every 30 seconds to get latest KYC pending count
      this.kycRequestsInterval = setInterval(() => {
        this.fetchKycCount();
      }, 30000);
    }

    this.common.setCookieExpire("expire", true, this.IDLE_TIMEOUT);
    document.onclick = () => {
      this.common.setCookieExpire("expire", true, this.IDLE_TIMEOUT);
    };
    document.onmousemove = () => {
      this.common.setCookieExpire("expire", true, this.IDLE_TIMEOUT);
    };
    document.onkeypress = () => {
      this.common.setCookieExpire("expire", true, this.IDLE_TIMEOUT);
    };
  }
  IDLE_TIMEOUT = 30 * 60; //seconds
  CheckIdleTime() {
    if (!this.common.getCookie("expire")) {
      clearInterval(this.headInterval);
      this.logOut();
      this.logoutService.warnMessage("Session Timeout");
    }
  }

  logOut(): void {
    this.loading = true;
    this.logoutService.logout().subscribe(
      (data) => {
        if (data.status === "success") {
          this.common.logout();
        } else {
          this.loading = false;
          this.common.logout();
        }
      },
      (err) => {
        this.loading = false;
        this.common.logout();
      }
    );
  }

  openLogoutModal() {
    swal({
      title: "",
      text: "Are you sure you want to logout?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      allowOutsideClick: false,
    }).then(() => {
      this.logOut();
    });
  }

  @Output() toggle = new EventEmitter();
  sideBarState: boolean = true;

  callParent() {
    this.sideBarState = !this.sideBarState;
    // if (this.sideBarState) {
    //   document.getElementById("header").style.marginLeft = "250px";
    // } else {
    //
    //   document.getElementById("header").style.marginLeft = "50px";
    // }
    this.toggle.next(this.sideBarState);
  }
  deleteResponse(id, index) {
    this.mess.splice(index, 1);
    this.notificationCount = this.mess.length;

    this.sendResponse(id, index, null, null);
  }
  sendResponse(id, index, url, userId) {
    if (url !== null) {
      this.notificationdownload(url, userId);
    }
    //   this.headerService.sendMessage(id, this.userId);
    this.message = "";
  }

  notificationdownload(url, userId) {
    this.headerService.downloadNotification(url, userId);
  }
  downloadFile(data: Response) {
    var blob = new Blob([data], { type: "text/csv" });
    var url = window.URL.createObjectURL(blob);
    window.open(url);
  }

  fetchInitialCount() {
    if (!this.shouldShowAgentRequestIcon) {
      return;
    }
    if (!localStorage.getItem("tkn")) {
      if (this.agentRequestsInterval) clearInterval(this.agentRequestsInterval);
      return;
    }
    try {
      this.agentRequestsService.getCountByStatus("PENDING").subscribe(
        (res) => {
          if (res && res.status === "success") {
            const count = res.object || res.count || 0;
            this.pendingAgentRequestsCount = count;
            localStorage.setItem("pendingAgentRequestsCount", count.toString());
            this.ref.detectChanges();
          } else {
            this.updateCountFromStorage();
          }
        },
        (error) => {
          this.updateCountFromStorage();
        }
      );
    } catch (error) {
      this.updateCountFromStorage();
    }
  }

  updateCountFromStorage() {
    const storedCount = localStorage.getItem("pendingAgentRequestsCount");
    if (storedCount !== null) {
      const count = parseInt(storedCount, 10) || 0;
      if (this.pendingAgentRequestsCount !== count) {
        this.pendingAgentRequestsCount = count;
        this.ref.detectChanges();
      }
    }
  }

  navigateToAgentRequests() {
    this.router.navigate(["/main/agent-requests"]);
  }

  fetchKycCount() {
    if (!this.shouldShowKycIcon) {
      return;
    }
    if (!localStorage.getItem("tkn")) {
      if (this.kycRequestsInterval) clearInterval(this.kycRequestsInterval);
      return;
    }
    try {
      const countObj = { status: "P" }; // P for pending
      this.kycService.getCount(countObj).subscribe(
        (res) => {
          if (res && (res.status === "SUCCESS" || res.status === "success")) {
            let count = 0;
            if (res.object) {
              try {
                const parsedObject = typeof res.object === 'string' ? JSON.parse(res.object) : res.object;
                count = (parsedObject && parsedObject.data) || (parsedObject && parsedObject.result && parsedObject.result.data) || 0;
              } catch (e) {
                // If parsing fails, try to use object directly as number
                count = parseInt(res.object, 10) || 0;
              }
            } else {
              count = res.count || 0;
            }
            this.pendingKycRequestsCount = count;
            localStorage.setItem("pendingKycRequestsCount", count.toString());
            this.ref.detectChanges();
          } else {
            this.updateKycCountFromStorage();
          }
        },
        (error) => {
          this.updateKycCountFromStorage();
        }
      );
    } catch (error) {
      this.updateKycCountFromStorage();
    }
  }

  updateKycCountFromStorage() {
    const storedCount = localStorage.getItem("pendingKycRequestsCount");
    if (storedCount !== null) {
      const count = parseInt(storedCount, 10) || 0;
      if (this.pendingKycRequestsCount !== count) {
        this.pendingKycRequestsCount = count;
        this.ref.detectChanges();
      }
    }
  }

  navigateToKyc() {
    this.router.navigate(["/main/kyc"]);
  }

  ngOnDestroy() {
    // this.connection.unsubscribe();
    clearInterval(this.headInterval);
    if (this.agentRequestsInterval) {
      clearInterval(this.agentRequestsInterval);
    }
    if (this.kycRequestsInterval) {
      clearInterval(this.kycRequestsInterval);
    }
  }
}



// WEBPACK FOOTER //
// /Users/ldt/Desktop/ARES-admin-frontend/src/app/main/header/header.component.ts